export default "__VITE_ASSET__dI7368cG__"